import { useState } from "react";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      setDone(data.message);
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(apiError(err, "Could not subscribe"));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p className="rounded-2xl bg-[var(--green-tint)] px-5 py-4 text-sm font-medium text-[var(--india-green-deep)]" data-testid="newsletter-success">
        {done}
      </p>
    );
  }

  return (
    <form onSubmit={submit} className={`flex ${compact ? "flex-col sm:flex-row" : "flex-col sm:flex-row"} gap-3`} data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" />
        <input
          data-testid="newsletter-email-input"
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="w-full rounded-full border border-[var(--line)] bg-white py-3 pl-11 pr-4 text-base outline-none transition-colors focus:border-[var(--chakra)] focus:ring-2 focus:ring-[var(--chakra-tint)]"
        />
      </div>
      <button
        type="submit" disabled={busy} data-testid="newsletter-submit-btn"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[var(--saffron)] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-200 transition-all hover:bg-[var(--saffron-deep)] disabled:opacity-60"
      >
        <Send className="h-4 w-4" /> {busy ? "Sending..." : "Subscribe"}
      </button>
    </form>
  );
}

export function NewsletterSection() {
  return (
    <section id="newsletter" className="relative z-10 scroll-mt-24 py-16" data-testid="newsletter-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="overflow-hidden rounded-3xl border border-[var(--line)] bg-white shadow-xl shadow-orange-100/50">
          <div className="tricolor-bar h-1.5" />
          <div className="grid gap-8 p-8 sm:p-12 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-7">
              <p className="eyebrow text-[var(--saffron-deep)]">डाक से जुड़िए · Stay connected</p>
              <h2 className="mt-3 font-serif text-3xl font-bold tracking-tight text-[var(--chakra-deep)] sm:text-4xl">Get a note when a new article is published</h2>
              <p className="mt-4 text-base text-stone-600 md:text-lg">
                No spam, no forwards. One short email each time a new story about Bharat goes live. Unsubscribe any time.
              </p>
            </div>
            <div className="lg:col-span-5">
              <NewsletterForm />
              <p className="mt-3 text-xs text-stone-500">We'll send a confirmation email first.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
